$("form.product-form").each(function () {
  if (
    $(this).find(".product-variant__item").length &&
    $(this).find(".selector-variant-container").length
  ) {
    $(this)
      .find("fieldset input")
      .change(function () {
        let parent = $(this).parents("form.product-form");
        parent.find("fieldset input").each(function () {
          if ($(this).is(":checked")) {
            const myArray = [];
            let item = $(this).parents("form.product-form");
            item.find("select option:selected").each(function () {
              let selector_value = $(this).val();
              let first_Value = selector_value
                .replace(/\s+/g, "-")
                .toLowerCase();
              myArray.push(first_Value);
            });
            item.find("fieldset input:checked").each(function () {
              let input_value = $(this).val();
              let second_Value = input_value.replace(/\s+/g, "-").toLowerCase();
              myArray.push(second_Value);
            });
            if (myArray.length > 0) {
              item.find("ul.hidden-variants-picker li").each(function () {
                var text = $(this).text();
                var arr = text.split("-");
                if (
                  myArray.sort().join("") == arr.sort().join("") &&
                  arr.length == myArray.length
                ) {
                  let pickID = $(this).attr("data-id");
                  item.find("input[type='hidden']").val(pickID);
                }
              });
            }
          }
        });
      });
    $(this)
      .find("select")
      .change(function () {
        let parent = $(this).parents("form.product-form");
        parent.find("fieldset input").each(function () {
          if ($(this).is(":checked")) {
            const myArray = [];
            let item = $(this).parents("form.product-form");
            item.find("select option:selected").each(function () {
              let selector_value = $(this).val();
              let first_Value = selector_value
                .replace(/\s+/g, "-")
                .toLowerCase();
              myArray.push(first_Value);
            });
            item.find("fieldset input:checked").each(function () {
              let input_value = $(this).val();
              let second_Value = input_value.replace(/\s+/g, "-").toLowerCase();
              myArray.push(second_Value);
            });
            if (myArray.length > 0) {
              item.find("ul.hidden-variants-picker li").each(function () {
                var text = $(this).text();
                var arr = text.split("-");
                if (
                  myArray.sort().join("") == arr.sort().join("") &&
                  arr.length == myArray.length
                ) {
                  let pickID = $(this).attr("data-id");
                  item.find("input[type='hidden']").val(pickID);
                }
              });
            }
          }
        });
      });
  } else if (
    $(this).find(".product-variant__item").length === 0 &&
    $(this).find(".selector-variant-container").length
  ) {
    $(this)
      .find("select")
      .change(function () {
        let parent = $(this).parents("form.product-form");
        parent.find("fieldset input").each(function () {
          if ($(this).is(":checked")) {
            const myArray = [];
            let item = $(this).parents("form.product-form");
            item.find("select option:selected").each(function () {
              let selector_value = $(this).val();
              let first_Value = selector_value
                .replace(/\s+/g, "-")
                .toLowerCase();
              myArray.push(first_Value);
            });
            item.find("fieldset input:checked").each(function () {
              let input_value = $(this).val();
              let second_Value = input_value.replace(/\s+/g, "-").toLowerCase();
              myArray.push(second_Value);
            });
            if (myArray.length > 0) {
              item.find("ul.hidden-variants-picker li").each(function () {
                var text = $(this).text();
                var arr = text.split("-");
                if (
                  myArray.sort().join("") == arr.sort().join("") &&
                  arr.length == myArray.length
                ) {
                  let pickID = $(this).attr("data-id");
                  item.find("input[type='hidden']").val(pickID);
                }
              });
            }
          }
        });
      });
  } else if (
    $(this).find(".product-variant__item").length &&
    $(this).find(".selector-variant-container").length === 0
  ) {
    $(this)
      .find("fieldset input")
      .change(function () {
        let parent = $(this).parents("form.product-form");
        parent.find("fieldset input").each(function () {
          if ($(this).is(":checked")) {
            const myArray = [];
            let item = $(this).parents("form.product-form");
            item.find("select option:selected").each(function () {
              let selector_value = $(this).val();
              let first_Value = selector_value
                .replace(/\s+/g, "-")
                .toLowerCase();
              myArray.push(first_Value);
            });
            item.find("fieldset input:checked").each(function () {
              let input_value = $(this).val();
              let second_Value = input_value.replace(/\s+/g, "-").toLowerCase();
              myArray.push(second_Value);
            });
            if (myArray.length > 0) {
              item.find("ul.hidden-variants-picker li").each(function () {
                var text = $(this).text();
                var arr = text.split("-");
                if (
                  myArray.sort().join("") == arr.sort().join("") &&
                  arr.length == myArray.length
                ) {
                  let pickID = $(this).attr("data-id");
                  item.find("input[type='hidden']").val(pickID);
                }
              });
            }
          }
        });
      });
  } else {
  }
});
$(document).on("submit", ".product-form", function (e) {
  let cartType = $(this).find(".product-card-addtocart").attr("data-cart-type");
  let text = $(this).find("span.secondary-text");
  let animation = $(this).find("span.custom-loading-cart-icon");
  text.hide();
  animation.fadeIn();
  $.ajax({
    url: "/cart/add.js",
    type: $(this).attr("method"),
    data: $(this).serialize(),
    dataType: 'json', 
    success: function (html) {
      console.log("added")
      animation.hide();
      text.show();
      if (cartType === "drawer") {
        refreshCart();
      } else {
        window.location.href = "/cart";
      }
    },
  });
  if (cartType === "drawer") {
    refreshCart();
  }
  e.preventDefault();
});